var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCloudRain } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Stack from "syf-component-library/ui/spacing/Stack";
import { ErrorBlock, ErrorCard, ErrorContainer } from "./subcomponents";
import getTranslation from "../../../strings/getTranslations";
var ErrorPage = function () {
    var t = getTranslation().t;
    return (_jsx(ErrorContainer, __assign({ "data-cy-include": true, "data-testid": "profile-error" }, { children: _jsxs(ErrorCard, __assign({ "data-cy": "error-card" }, { children: [_jsx(Stack, { size: "large" }), _jsx(FontAwesomeIcon, { color: "#34657F", size: "4x", icon: faCloudRain }), _jsx(Stack, { size: "large" }), _jsx(ErrorBlock, __assign({ size: 24, weight: "semiBold" }, { children: t("errorPage.title") })), _jsx(Stack, { size: "large" }), _jsx(ErrorBlock, { children: t("errorPage.description") }), _jsx(Stack, { size: "large" }), _jsx(ErrorBlock, { children: t("errorPage.tryAgain") }), _jsx(Stack, { size: "xlarge" })] })) })));
};
export default ErrorPage;
